import React from 'react';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import './CTABanner.css';

const CTABanner = ({
  title = 'Kombi, klima veya beyaz eşyanız mı arızalı?',
  subtitle = '7/24 teknik servis hattımız aramanızı bekliyor. Aynı gün yerinde servis.',
}) => {
  return (
    <section className="cta-banner" aria-label="Hızlı iletişim">
      <div className="cta-banner-inner">
        <h2 className="cta-banner-title">{title}</h2>
        <p className="cta-banner-subtitle">{subtitle}</p>
        <div className="btn-group cta-banner-actions">
          <a href={SITE.phoneHref} className="btn btn-call">
            <FaPhoneAlt className="btn-icon" /> Hemen Ara
          </a>
          <a
            href={SITE.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-whatsapp"
          >
            <FaWhatsapp className="btn-icon" /> WhatsApp'tan Yaz
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
